import React, { FC } from 'react';
import { withRouter, Redirect } from 'react-router';
import { useParams } from 'react-router-dom';

import * as paths from 'paths';
import { BootstrapUserComponent } from 'api';
import { Queries, QueryManager } from 'components';
import { FOLLOW_QUERIES_LIMIT } from 'constants/index';

import { ProfileController } from '../components';

interface IMatchParams {
  profile_id: string;
}

const Profile: FC = () => {
  const { profile_id } = useParams<IMatchParams>();
  const variables = { user_id: profile_id, limit: FOLLOW_QUERIES_LIMIT };

  return (
    <BootstrapUserComponent variables={{ user_id: profile_id }}>
      {queryResult => (
        <QueryManager {...queryResult}>
          {({ data }) => {
            if (!data || !data.bootstrap) {
              return <Redirect to={paths.people} />;
            }
            return (
              <Queries.GetFollowed variables={variables}>
                {followedResult => (
                  <Queries.GetFollowers variables={variables}>
                    {followersResult => {
                      const profileData = {
                        user: data.bootstrap.user,
                        followedResult,
                        followersResult,
                      };

                      return <ProfileController data={profileData} />;
                    }}
                  </Queries.GetFollowers>
                )}
              </Queries.GetFollowed>
            );
          }}
        </QueryManager>
      )}
    </BootstrapUserComponent>
  );
};

export default withRouter(Profile);
